import { WithId } from '@common/typescript/objects/WithId';

export interface EmailLogEntry {
	id: number;
	type: EmailLogType;
	status: EmailLogStatus;
	date: number;
	recipient: string;
}

export enum EmailType {
	ClinicPetEmail = 1,
	SpreadCoordinatesEmail = 2,
	TrackingNumberEmail = 3,
	MemorialPetEmail = 4,
}

export const emailTypeName: Record<EmailType, string> = {
	[EmailType.ClinicPetEmail]: 'Clinic',
	[EmailType.SpreadCoordinatesEmail]: 'Spread Coordinates',
	[EmailType.TrackingNumberEmail]: 'Tracking Number',
	[EmailType.MemorialPetEmail]: 'Memorial Services',
};

export enum MailStatus {
	Unknown = 0,
	Success = 1,
	Fail = 2,
	Pending = 3,
}

export interface PetEmailLogView extends WithId {
	dateTime: number,
	status: MailStatus,
	type: EmailType,
}

export enum EmailLogType {
	Inventory = 0,
	Delivery = 1,
	Invoice = 2,
}

export enum EmailLogStatus {
	Sent = 0,
	Failure = 1,
	Pending = 2,
}

export const emailLogTypeName: Record<EmailLogType, string> = {
	[EmailLogType.Inventory]: 'Inventory',
	[EmailLogType.Delivery]: 'Delivery',
	[EmailLogType.Invoice]: 'Invoice',
};

export const emailLogStatusName: Record<EmailLogStatus, string> = {
	[EmailLogStatus.Sent]: 'Sent',
	[EmailLogStatus.Failure]: 'Failure',
	[EmailLogStatus.Pending]: 'Pending',
};
